import { IBuilder, Builder } from 'builder-pattern';
import { Avatar3DInterface } from '../avatar-3d/avatar-3d.interface';
import { GenderEnum } from '../../enums';

export interface UserInfoInterface {
  userID: number;
  username: string;
  profilePicture: string;
  smallProfilePicture: string;

  // statistics
  points: number;
  coins: number;
  allGames: number;
  wonGames: number;
  lostGames: number;
  leftGames: number;
  wonSchneider: number;
  lostSchneider: number;
  wonRetourschneider: number;
  lostRetourschneider: number;

  // flags
  isFriend: boolean;
  isEnemy: boolean;
  hasDonated: boolean;
  premiumBadge?: boolean; // Stammtisch-Abo subscriber with badge enabled
  hasEnemiedMe: boolean;
  isGoogleLogin: boolean; // just for me via player-info endpoint
  hasPassword: boolean; // just for me via player-info endpoint — true if a local password is set
  isFriendshipRequest: boolean; // true if the user has gotten a friendship request from me
  hasSentFriendshipRequest: boolean; // true if the user has sent me a friendship request

  email: string; // just for me via player-info endpoint
  lastUsernameChange: Date | undefined; //  // just for me via player-info endpoint
  donationSum: number; // just for me via player-info endpoint
  isLocked: boolean; // just for me via player-info endpoint
  isAdmin: boolean; // just for me via player-info endpoint
  enemies: number[]; // just for me via player-info endpoint

  // Impersonation data from backend
  impersonation?: {
    isImpersonating: boolean;
    originalAdmin?: {
      userID: number;
      username: string;
      impersonationStartedAt: string;
    };
    impersonatedUser?: {
      id: number;
      username: string;
    };
  };

  tableID: number; // not always!
  isInGame: boolean; // not always!
  table: any | undefined; // not always!
  watchingTableID: number; // not always!

  // just for messages
  hasNoUnreadMessages: boolean;
  hasUnreadMessages: boolean;

  registrationDate: Date;

  avatar3d: Avatar3DInterface;
  about: string; // User's personal "about me" text
  gender?: GenderEnum; // User's gender

  // Social Features - User Status System
  status?: string; // User status message
  statusEmoji?: string; // Status emoji
  statusUpdatedAt?: Date; // When status was last updated

  // Guest User System
  isGuest?: boolean; // Whether user is a guest
  guestExpiryDate?: Date; // When guest account expires

  // Leave After Bummerl
  wantToLeaveAfterBummerl?: boolean | Date; // Server-side status for wanting to leave after bummerl
}

export namespace UserInfoInterface {
  export function builder(
    template?: Partial<UserInfoInterface>
  ): IBuilder<UserInfoInterface> {
    return Builder<UserInfoInterface>(template);
  }
}
